module.exports = __webpack_public_path__ + "static/media/jp.b5b509c8.svg";